import { render, staticRenderFns } from "./FaqTopics.vue?vue&type=template&id=b0e5f640&scoped=true&"
import script from "./FaqTopics.vue?vue&type=script&lang=js&"
export * from "./FaqTopics.vue?vue&type=script&lang=js&"
import style0 from "./FaqTopics.vue?vue&type=style&index=0&id=b0e5f640&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e5f640",
  null
  
)

export default component.exports